import clsx from "clsx";
import { useId } from "react";
import Input, { InputProps } from "../input";
import ControlGroupAddon from "./controlGroupAddon";
import { useControlGroupSize } from "./context";

export interface ControlGroupCheckboxProps extends InputProps {
  label?: React.ReactNode;
  type?: "checkbox" | "radio";
}

export default function ControlGroupCheckbox({
  className,
  id: providedId,
  label,
  size,
  type = "checkbox",
  ...props
}: Readonly<ControlGroupCheckboxProps>) {
  const generatedId = useId();
  const id = providedId ?? generatedId;
  const resolvedSize = useControlGroupSize(size);

  return (
    <ControlGroupAddon size={resolvedSize} className="gap-2">
      <Input
        {...props}
        id={id}
        type={type}
        size={resolvedSize}
        className={clsx("cursor-pointer", className)}
      />
      {label && (
        <label htmlFor={id} className="flex-1 cursor-pointer">
          {label}
        </label>
      )}
    </ControlGroupAddon>
  );
}
